/*jshint esversion: 6 */
// Navigation Components -------------------------------------- *
import '../Views/Feature/Navigation/UniversalUtilityBrandBar/utilityBrandBar';
import '../Views/Feature/Navigation/UniversalHeader/UniversalHeader';
import '../Views/Feature/Navigation/GlobalAlert/globalAlert';
import '../Views/Feature/Navigation/CookieDisclaimer/cookieDisclaimer';
import '../Views/Feature/Navigation/GatedContent/gatedContent';
import '../Views/Feature/Navigation/UniversalHeader/solrSearch';
import '../Views/Feature/Navigation/BrandBar/brandBar';